<template>
  <v-card>
    <v-card-title :class="contractColor">
      <v-row justify="space-between" align="center">
        <v-col cols="auto">
          <span class="headline">{{ title }} </span>
        </v-col>

        <v-col cols="auto">
          <BaseDialogActions hideRefresh/>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="pt-6">
      <v-row>
        <v-col cols="12" lg="6">
          <ReadOnlyAttributeCard
            :label="$t('product')"
            :value="detail.product.name"/>
        </v-col>

        <v-col cols="12" lg="6" :style="{ height: '100px' }">
          <MoneyTextField
          :initialValue="detail.cost.rate"
          :itemId="`${activity.activityId}-${detail.activityDetailId}`"
          :minimumValueConfig="{ min: activity.baseCost.rate, error: $t('baseRateLowerThanActivity') }"
          :label="$t('rate')"
          @val-changed="baseRateEnteredForProduct"
          :extraRules="['validActivityRate']"
          elementId="rate"
          :focus="focusRate"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="py-4 px-0">
      <v-row justify="end">
        <v-col cols="auto">
          <v-btn @click="confirmClicked" :class="contractColor">
            {{ $t('confirm') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  AccountingCategory, RuntimeCounterparty
} from '@/utils/Enumerations'
import { cloneDeep } from 'lodash'
import { colorClassForContractType } from '@/utils/componentHelpers.js'

export default {
  name: 'ContractDetailScheduledChangeForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    ReadOnlyAttributeCard: () => import('@/components/helper/ReadOnlyAttributeCard.vue'),
    MoneyTextField: () => import('@/components/helper/MoneyTextField.vue')
  },

  props: {
    contract: {
      type: Object,
      required: true
    },

    activity: {
      type: Object,
      required: true
    },

    detail: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    AccountingCategory,
    detailBuilder: null,
    focusRate: false
  }),

  computed: {
    title () {
      return `${this.$t('scheduleRateChanges')} - ${this.activity.activityTemplate.name} - ${this.detail.product.name}`
    },

    counterparty () {
      if (this.activity.contractor) {
        return this.activity.contractor.name
      } else {
        return RuntimeCounterparty.fromInt(this.activity.runtimeCounterparty)
      }
    },

    contractColor () {
      return colorClassForContractType(this.contract.type)
    }
  },

  created () {
    this.detailBuilder = cloneDeep(this.detail)
  },

  mounted () {
    this.$nextTick(() => {
      this.focusRate = true
    })
  },

  methods: {
    confirmClicked () {
      this.$emit('confirmed', this.detailBuilder)
    },

    baseRateEnteredForProduct (rate) {
      this.detailBuilder.cost.rate = parseFloat(rate)
    }
  }
}
</script>
